import * as React from "react";
import isElectron from "is-electron";
import styled from "styled-components";
import { Link, useHistory } from "react-router-dom";
import { ENVSETTINGKEY, LOGININFOSTORE, LOGINTOKEN } from "@/config/const";
import { Radio } from "antd";
import { storage } from "@/util";

const Container = styled.div`
  padding: 60px 60px 0 20px;
  .item {
    padding: 10px 0;
  }
`;

const EnvSetting: React.FunctionComponent = () => {
  const history = useHistory();
  const aenv = storage.get(ENVSETTINGKEY) || "online";
  const [env, setEnv] = React.useState(aenv);

  const options = [
    { label: "测试环境", value: "test" },
    { label: "正式环境", value: "online" },
  ];

  const changeHandler = (e: any) => {
    const v = e.target.value;
    setEnv(v);
    storage.save(ENVSETTINGKEY, v);
    storage.remove(LOGININFOSTORE);
    storage.remove(LOGINTOKEN);
    if(isElectron()){
      alert(`将切换到${v=="online"?`线上环境`:`正式环境`}`);
      history.replace("/");
    }else{
      window.location.href = "/";
    }
    //window.location.href = "/";
    //history.replace("/");
  };

  return (
    <Container className="f1">
      <p className="mb20 mt20">设置所用环境</p>

      <Radio.Group
        options={options}
        onChange={changeHandler}
        value={env}
        optionType="button"
        buttonStyle="solid"
      />
    </Container>
  );
};

export default EnvSetting;
